import { IsNotEmpty, MaxLength, Validate, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContactsValidation } from 'src/core/customValidator/contactsValidator';
import { OfficeDynamicPropertyValidator } from 'src/core/customValidator/officeDynamicPropertyValidator';

export class TransportCompanyOfficeListDataService extends DataService<typeof Model.Products.Logic.ViewModels.TransportCompanyOfficeItem, Model.Products.Logic.ViewModels.TransportCompanyOfficeItem, TransportCompanyOfficeItem> {
	protected map(entity: Model.Products.Logic.ViewModels.TransportCompanyOfficeItem): TransportCompanyOfficeItem {
		return new TransportCompanyOfficeItemModel(entity);
	}

	static make(context?: any): TransportCompanyOfficeListDataService {
		return new TransportCompanyOfficeListDataService(context, ctx => ctx.TransportCompanyOffices);
	}

	add(supplier: SupplierItem) {
		const entity = new Model.Products.Logic.ViewModels.TransportCompanyOfficeItem();
		entity.code = '';
		if (supplier.id > 0) {
			entity.supplierId = supplier.id;
		} else {
			entity.supplier = supplier.entity;
		}
		entity.title = '';

		const dynamicProperties = (<any>entity).dynamicProperties;
		dynamicProperties['contacts'] = [];
		dynamicProperties['openingHour'] = null;
		dynamicProperties['closingHour'] = null;
		return entity;
	}
}

export class TransportCompanyOfficeItemModel extends EntityModel<Model.Products.Logic.ViewModels.TransportCompanyOfficeItem, TransportCompanyOfficeItem> implements TransportCompanyOfficeItem {
	@property<TransportCompanyOfficeItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<TransportCompanyOfficeItemModel>(o => o.entity.placeId, (o, value) => o.entity.placeId = value)
	@IsDefined({ message: 'Place is required' })
	public placeId: number;

	@property<TransportCompanyOfficeItemModel>(o => o.entity.code, (o, value) => o.entity.code = value)
	@IsDefined({ message: 'Code is required' })
	@IsNotEmpty({ message: 'Code is required' })
	@MaxLength(32)
	public code: string;

	@property<TransportCompanyOfficeItemModel>(o => o.entity.title, (o, value) => o.entity.title = value)
	@IsDefined({ message: 'Title  is required' })
	@IsNotEmpty({ message: 'Title  is required' })
	@MaxLength(256, { message: 'Title is too long' })
	public title: string;

	@property<TransportCompanyOfficeItemModel>(o => o.entity.supplierId, (o, value) => o.entity.supplierId = value)
	public supplierId: number;

	@property<TransportCompanyOfficeItemModel>(o => o.entity.supplier, (o, value) => o.entity.supplier = value)
	public supplier: any;

	@property<TransportCompanyOfficeItemModel>(o => o.entity.canPickup, (o, value) => o.entity.canPickup = value)
	public canPickup: boolean;

	@property<TransportCompanyOfficeItemModel>(o => o.entity.canDropoff, (o, value) => o.entity.canDropoff = value)
	public canDropoff: boolean;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(ContactsValidation)
	@Validate(OfficeDynamicPropertyValidator)
	public dynamicProperties: {};

	constructor(entity: Model.Products.Logic.ViewModels.TransportCompanyOfficeItem) {
		super(entity);
	}
}




// WEBPACK FOOTER //
// ./src/app/products/office/office.data.ts